export class AuthRoutes {
  static readonly Login = 'login';
  static readonly Logout = 'logout';
  static readonly ChangePassword = 'change-password';
  static readonly ForgotPassword = 'forgot-password';
  static readonly ResetPassword = 'resetpassword';
  static readonly ForceResetPassword = 'force-password-reset';
  static readonly SetupMFA = 'setup-mfa';
  static readonly Signup = 'signup';
  static readonly Verify = 'verify';
  static readonly ActivateAccount = 'confirm';
  static readonly ImpersonateGuid = 'auth/impersonate/:guid';
  static readonly Impersonate = 'auth/impersonate';
  static readonly InvalidUser = 'invalid-user';
  static readonly InvalidInvitation = 'invalid-invitation';
  static readonly ValidateInvitation = 'activate';
}
